/*
DoubleIncFormulaIcon.js
双增公式的一个SVG图片
 */

import React from "react";

export const DoubleIncFormulaIcon = (props) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -1543.9 20177.7 2513.9" preserveAspectRatio="xMidYMid meet"
             aria-hidden="true" {...props}>
            <defs>
                <path id="MJX-7-TEX-N-28"
                      d="M94 250Q94 319 104 381T127 488T164 576T202 643T244 695T277 729T302 750H315H319Q333 750 333 741Q333 738 316 720T275 667T226 581T184 443T167 250T184 58T225 -81T274 -167T316 -220T333 -241Q333 -250 318 -250H315H302L274 -226Q180 -141 137 -14T94 250Z"></path>
                <path id="MJX-7-TEX-I-1D461"
                      d="M26 385Q19 392 19 395Q19 399 22 411T27 425Q29 430 36 430T87 431H140L159 511Q162 522 166 540T173 566T179 586T187 603T197 615T211 624T229 626Q247 625 254 615T261 596Q261 589 252 549T232 470L222 433Q222 431 272 431H323Q330 424 330 420Q330 398 317 385H210L174 240Q135 80 135 68Q135 26 162 26Q197 26 230 60T283 144Q285 150 288 151T303 153H307Q322 153 322 145Q322 142 319 133Q314 117 301 95T267 48T216 6T155 -11Q125 -11 98 4T59 56Q57 64 57 83V101L92 241Q127 382 128 383Q128 385 77 385H26Z"></path>
                <path id="MJX-7-TEX-N-32"
                      d="M109 429Q82 429 66 447T50 491Q50 562 103 614T235 666Q326 666 387 610T449 465Q449 422 429 383T381 315T301 241Q265 210 201 149L142 93L218 92Q375 92 385 97Q392 99 409 186V189H449V186Q448 183 436 95T421 3V0H50V19V31Q50 38 56 46T86 81Q115 113 136 137Q145 147 170 174T204 211T233 244T261 278T284 308T305 340T320 369T333 401T340 431T343 464Q343 527 309 573T212 619Q179 619 154 602T119 569T109 550Q109 549 114 549Q132 549 151 535T170 489Q170 464 154 447T109 429Z"></path>
                <path id="MJX-7-TEX-N-2B"
                      d="M56 237T56 250T70 270H369V420L370 570Q380 583 389 583Q402 583 409 568V270H707Q722 262 722 250T707 230H409V-68Q401 -82 391 -82H389H387Q375 -82 369 -68V230H70Q56 237 56 250Z"></path>
                <path id="MJX-7-TEX-N-37"
                      d="M55 458Q56 460 72 567L88 674Q88 676 108 676H128V672Q128 662 143 655T195 646T364 644H485V605L417 512Q408 500 387 472T360 435T339 403T319 367T305 330T292 284T284 230T278 162T275 80Q275 66 275 52T274 28V19Q270 2 255 -10T221 -22Q210 -22 200 -19T179 0T168 40Q168 198 265 368Q285 400 349 489L395 552H302Q128 552 119 546Q113 543 108 522T98 479L95 458V455H55V458Z"></path>
                <path id="MJX-7-TEX-N-33"
                      d="M127 463Q100 463 85 480T69 524Q69 579 117 622T233 665Q268 665 277 664Q351 652 390 611T430 522Q430 470 396 421T302 350L299 348Q299 347 308 345T337 336T375 315Q457 262 457 175Q457 96 395 37T238 -22Q158 -22 100 21T42 130Q42 158 60 175T105 193Q133 193 151 175T169 130Q169 119 166 110T159 94T148 82T136 74T126 70T118 67L114 66Q165 21 238 21Q293 21 321 74Q338 107 338 175V195Q338 290 274 322Q259 328 213 329L171 330L168 332Q166 335 166 348Q166 366 174 366Q202 366 232 371Q266 376 294 413T322 525V533Q322 590 287 612Q265 626 240 626Q208 626 181 615T143 592T132 580H135Q138 579 143 578T153 573T165 566T175 555T183 540T186 520Q186 498 172 481T127 463Z"></path>
                <path id="MJX-7-TEX-N-2E"
                      d="M78 60Q78 84 95 102T138 120Q162 120 180 104T199 61Q199 36 182 18T139 0T96 17T78 60Z"></path>
                <path id="MJX-7-TEX-N-31"
                      d="M213 578L200 573Q186 568 160 563T102 556H83V602H102Q149 604 189 617T245 641T273 663Q275 666 285 666Q294 666 302 660V361L303 61Q310 54 315 52T339 48T401 46H427V0H416Q395 3 257 3Q121 3 100 0H88V46H114Q136 46 152 46T177 47T193 50T201 52T207 57T213 61V578Z"></path>
                <path id="MJX-7-TEX-N-35"
                      d="M164 157Q164 133 148 117T109 101H102Q148 22 224 22Q294 22 326 82Q345 115 345 210Q345 313 318 349Q292 382 260 382H254Q176 382 136 314Q132 307 129 306T114 304Q97 304 95 310Q93 314 93 485V614Q93 664 98 664Q100 666 102 666Q103 666 123 658T178 642T253 634Q324 634 389 662Q397 666 402 666Q410 666 410 648V635Q328 538 205 538Q174 538 149 544L139 546V374Q158 388 169 396T205 412T256 420Q337 420 393 355T449 201Q449 109 385 44T229 -22Q148 -22 99 32T50 154Q50 178 61 192T84 210T107 214Q132 214 148 197T164 157Z"></path>
                <path id="MJX-7-TEX-N-29"
                      d="M60 749L64 750Q69 750 74 750H86L114 726Q208 641 251 514T294 250Q294 182 284 119T261 12T224 -76T186 -143T145 -194T113 -227T90 -246Q87 -249 86 -250H74Q66 -250 63 -250T58 -247T55 -238Q56 -237 66 -225Q221 -64 221 250T66 725Q56 737 55 738Q55 746 60 749Z"></path>
                <path id="MJX-7-TEX-N-2212" d="M84 237T84 250T98 270H679Q694 262 694 250T679 230H98Q84 237 84 250Z"></path>
                <path id="MJX-7-TEX-N-39"
                      d="M352 287Q304 211 232 211Q154 211 104 270T44 396Q42 412 42 436V444Q42 537 111 606Q171 666 243 666Q245 666 249 666T257 665H261Q273 665 286 663T323 651T370 619T413 560Q456 472 456 334Q456 194 396 97Q361 41 312 10T208 -22Q147 -22 108 7T68 93T121 149Q143 149 158 135T173 96Q173 78 164 65T148 49T135 44L131 43Q131 41 138 37T164 27T206 22H212Q272 22 313 86Q352 142 352 280V287ZM244 248Q292 248 321 297T351 430Q351 508 343 542Q341 552 337 562T323 588T293 615T246 625Q208 625 181 598Q160 576 154 546T147 441Q147 358 152 329T172 282Q197 248 244 248Z"></path>
                <path id="MJX-7-TEX-N-3D"
                      d="M56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153Z"></path>
                <path id="MJX-7-TEX-I-1D43E"
                      d="M285 628Q285 635 228 637Q205 637 198 638T191 647Q191 649 193 661Q199 681 203 682Q205 683 214 683H219Q260 681 355 681Q389 681 418 681T463 682T483 682Q500 682 500 674Q500 669 497 660Q496 658 496 654T495 648T493 644T490 641T486 639T479 638T470 637T456 637Q416 636 405 634T387 623L306 305Q307 305 490 449T678 597Q692 611 692 620Q692 635 667 637Q651 637 651 648Q651 650 654 662T659 677Q662 682 676 682Q680 682 711 681T791 680Q814 680 839 681T869 682Q889 682 889 672Q889 650 881 642Q878 637 862 637Q787 632 726 586Q710 576 656 534T556 455L509 418L518 396Q527 374 546 329T581 244Q656 67 661 61Q663 59 666 57Q680 47 717 46H738Q744 38 744 37T741 19Q737 6 731 0H720Q680 3 625 3Q503 3 488 0H478Q472 6 472 9T474 27Q478 40 480 43T491 46H494Q544 46 544 71Q544 75 517 141T485 216L427 354L359 301L291 248L268 155Q245 63 245 58Q245 51 253 49T303 46H334Q340 37 340 35Q340 19 333 5Q328 0 317 0Q314 0 280 1T180 2Q118 2 85 2T49 1Q31 1 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628Z"></path>
            </defs>
            <g stroke="currentColor" fill="currentColor" strokeWidth="0" transform="matrix(1 0 0 -1 0 0)">
                <g data-mml-node="math">
                    <g data-mml-node="mfrac">
                        <g data-mml-node="mrow" transform="translate(220, 710)">
                            <g data-mml-node="mo">
                                <use xlinkHref="#MJX-7-TEX-N-28"></use>
                            </g>
                            <g data-mml-node="msub" transform="translate(389, 0)">
                                <g data-mml-node="mi">
                                    <use xlinkHref="#MJX-7-TEX-I-1D461"></use>
                                </g>
                                <g data-mml-node="TeXAtom" transform="translate(361, -150) scale(0.707)"
                                   data-mjx-texclass="ORD">
                                    <g data-mml-node="mn">
                                        <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                    </g>
                                </g>
                            </g>
                            <g data-mml-node="mo" transform="translate(1375.8, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-2B"></use>
                            </g>
                            <g data-mml-node="mn" transform="translate(2376, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                <use xlinkHref="#MJX-7-TEX-N-37" transform="translate(500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-33" transform="translate(1000, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-2E" transform="translate(1500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-31" transform="translate(1778, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-35" transform="translate(2278, 0)"></use>
                            </g>
                            <g data-mml-node="msup" transform="translate(5154, 0)">
                                <g data-mml-node="mo">
                                    <use xlinkHref="#MJX-7-TEX-N-29"></use>
                                </g>
                                <g data-mml-node="TeXAtom" transform="translate(389, 363) scale(0.707)"
                                   data-mjx-texclass="ORD">
                                    <g data-mml-node="mn">
                                        <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                    </g>
                                </g>
                            </g>
                            <g data-mml-node="mo" transform="translate(6168.8, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-2212"></use>
                            </g>
                            <g data-mml-node="mo" transform="translate(7169, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-28"></use>
                            </g>
                            <g data-mml-node="mn" transform="translate(7558, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                <use xlinkHref="#MJX-7-TEX-N-39" transform="translate(500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-33" transform="translate(1000, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-2E" transform="translate(1500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-31" transform="translate(1778, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-35" transform="translate(2278, 0)"></use>
                            </g>
                            <g data-mml-node="msup" transform="translate(10336, 0)">
                                <g data-mml-node="mo">
                                    <use xlinkHref="#MJX-7-TEX-N-29"></use>
                                </g>
                                <g data-mml-node="TeXAtom" transform="translate(389, 363) scale(0.707)"
                                   data-mjx-texclass="ORD">
                                    <g data-mml-node="mn">
                                        <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g data-mml-node="mrow" transform="translate(220, -719.9)">
                            <g data-mml-node="mo">
                                <use xlinkHref="#MJX-7-TEX-N-28"></use>
                            </g>
                            <g data-mml-node="msub" transform="translate(389, 0)">
                                <g data-mml-node="mi">
                                    <use xlinkHref="#MJX-7-TEX-I-1D461"></use>
                                </g>
                                <g data-mml-node="TeXAtom" transform="translate(361, -150) scale(0.707)"
                                   data-mjx-texclass="ORD">
                                    <g data-mml-node="mn">
                                        <use xlinkHref="#MJX-7-TEX-N-31"></use>
                                    </g>
                                </g>
                            </g>
                            <g data-mml-node="mo" transform="translate(1375.8, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-2B"></use>
                            </g>
                            <g data-mml-node="mn" transform="translate(2376, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                <use xlinkHref="#MJX-7-TEX-N-37" transform="translate(500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-33" transform="translate(1000, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-2E" transform="translate(1500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-31" transform="translate(1778, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-35" transform="translate(2278, 0)"></use>
                            </g>
                            <g data-mml-node="msup" transform="translate(5154, 0)">
                                <g data-mml-node="mo">
                                    <use xlinkHref="#MJX-7-TEX-N-29"></use>
                                </g>
                                <g data-mml-node="TeXAtom" transform="translate(389, 289) scale(0.707)"
                                   data-mjx-texclass="ORD">
                                    <g data-mml-node="mn">
                                        <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                    </g>
                                </g>
                            </g>
                            <g data-mml-node="mo" transform="translate(6168.8, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-2212"></use>
                            </g>
                            <g data-mml-node="mo" transform="translate(7169, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-28"></use>
                            </g>
                            <g data-mml-node="mn" transform="translate(7558, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                <use xlinkHref="#MJX-7-TEX-N-39" transform="translate(500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-33" transform="translate(1000, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-2E" transform="translate(1500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-31" transform="translate(1778, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-35" transform="translate(2278, 0)"></use>
                            </g>
                            <g data-mml-node="msup" transform="translate(10336, 0)">
                                <g data-mml-node="mo">
                                    <use xlinkHref="#MJX-7-TEX-N-29"></use>
                                </g>
                                <g data-mml-node="TeXAtom" transform="translate(389, 289) scale(0.707)"
                                   data-mjx-texclass="ORD">
                                    <g data-mml-node="mn">
                                        <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <rect width="11328.5" height="60" x="120" y="220"></rect>
                    </g>
                    <g data-mml-node="mo" transform="translate(11846.3, 0)">
                        <use xlinkHref="#MJX-7-TEX-N-3D"></use>
                    </g>
                    <g data-mml-node="mstyle" fill="red" stroke="red" transform="translate(12902.1, 0)">
                        <g data-mml-node="mi">
                            <use xlinkHref="#MJX-7-TEX-I-1D43E"></use>
                        </g>
                    </g>
                    <g data-mml-node="mfrac" transform="translate(13791.1, 0)">
                        <g data-mml-node="mrow" transform="translate(220, 710)">
                            <g data-mml-node="mo">
                                <use xlinkHref="#MJX-7-TEX-N-28"></use>
                            </g>
                            <g data-mml-node="msub" transform="translate(389, 0)">
                                <g data-mml-node="mi">
                                    <use xlinkHref="#MJX-7-TEX-I-1D461"></use>
                                </g>
                                <g data-mml-node="TeXAtom" transform="translate(361, -150) scale(0.707)"
                                   data-mjx-texclass="ORD">
                                    <g data-mml-node="mn">
                                        <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                    </g>
                                </g>
                            </g>
                            <g data-mml-node="mo" transform="translate(1375.8, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-2B"></use>
                            </g>
                            <g data-mml-node="mn" transform="translate(2376, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                <use xlinkHref="#MJX-7-TEX-N-37" transform="translate(500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-33" transform="translate(1000, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-2E" transform="translate(1500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-31" transform="translate(1778, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-35" transform="translate(2278, 0)"></use>
                            </g>
                            <g data-mml-node="msup" transform="translate(5154, 0)">
                                <g data-mml-node="mo">
                                    <use xlinkHref="#MJX-7-TEX-N-29"></use>
                                </g>
                                <g data-mml-node="TeXAtom" transform="translate(389, 363) scale(0.707)"
                                   data-mjx-texclass="ORD">
                                    <g data-mml-node="mn">
                                        <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g data-mml-node="mrow" transform="translate(220, -719.9)">
                            <g data-mml-node="mo">
                                <use xlinkHref="#MJX-7-TEX-N-28"></use>
                            </g>
                            <g data-mml-node="msub" transform="translate(389, 0)">
                                <g data-mml-node="mi">
                                    <use xlinkHref="#MJX-7-TEX-I-1D461"></use>
                                </g>
                                <g data-mml-node="TeXAtom" transform="translate(361, -150) scale(0.707)"
                                   data-mjx-texclass="ORD">
                                    <g data-mml-node="mn">
                                        <use xlinkHref="#MJX-7-TEX-N-31"></use>
                                    </g>
                                </g>
                            </g>
                            <g data-mml-node="mo" transform="translate(1375.8, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-2B"></use>
                            </g>
                            <g data-mml-node="mn" transform="translate(2376, 0)">
                                <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                <use xlinkHref="#MJX-7-TEX-N-37" transform="translate(500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-33" transform="translate(1000, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-2E" transform="translate(1500, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-31" transform="translate(1778, 0)"></use>
                                <use xlinkHref="#MJX-7-TEX-N-35" transform="translate(2278, 0)"></use>
                            </g>
                            <g data-mml-node="msup" transform="translate(5154, 0)">
                                <g data-mml-node="mo">
                                    <use xlinkHref="#MJX-7-TEX-N-29"></use>
                                </g>
                                <g data-mml-node="TeXAtom" transform="translate(389, 289) scale(0.707)"
                                   data-mjx-texclass="ORD">
                                    <g data-mml-node="mn">
                                        <use xlinkHref="#MJX-7-TEX-N-32"></use>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <rect width="6146.6" height="60" x="120" y="220"></rect>
                    </g>
                </g>
            </g>
        </svg>
    )
;